export default __webpack_public_path__ + "static/media/Logo_Trust_LAS@3x.b3fb0050.png";